module.exports = __webpack_public_path__ + "static/media/warningCross.af81654a.svg";